import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private hideHeaderSubject = new BehaviorSubject<boolean>(false);
  hideHeader$ = this.hideHeaderSubject.asObservable();

  setHideHeader(value: boolean) {
    this.hideHeaderSubject.next(value);
  }
}
